import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';

var ConfiguratorStep = (_param)=>{
    var { children , className  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "children",
        "className"
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames('configurator-step', className),
        "data-t": rest['data-t']
    }, children);
};

export { ConfiguratorStep };
//# sourceMappingURL=ConfiguratorStep.js.map
